import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Palette {
    black: Palette['primary'];
    white?: Palette['primary'];
  }

  interface PaletteOptions {
    black: PaletteOptions['primary'];
    white?: PaletteOptions['primary'];
  }
}

export default createTheme({
  components: {
    // Icon buttons sit in tight clusters in the top bars, so they keep a roomier
    // hit area than the default. Small/large sizes keep their own padding.
    MuiIconButton: {
      styleOverrides: {
        sizeMedium: { padding: 12 },
      },
    },
    // Buttons in this app are neutral by default; `color` is opt-in for emphasis.
    MuiButton: {
      defaultProps: { color: 'inherit' },
      styleOverrides: {
        // A neutral `contained` button is grey, so its label follows the text colour
        // rather than inheriting a light colour from whatever surrounds it.
        contained: ({ ownerState, theme }) => (ownerState.color === 'inherit' ? { color: theme.palette.text.primary } : {}),
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 600,
      lg: 900,
      xl: 1200,
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", sans-serif',
    h1: {
      color: '#222222',
      textAlign: 'left',
      fontWeight: 700,
      fontSize: '3rem',
      fontFamily: '"Oswald", sans-serif',
      marginTop: 'auto',
      marginBottom: 'auto',
      whiteSpace: 'normal',
      paddingBottom: 8,
      '@media only screen and (max-width: 900px)': {
        fontSize: '2rem',
      },
    },
    h2: {
      color: '#111111',
      textAlign: 'left',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginTop: 16,
      marginBottom: 8,
    },
    h3: {
      color: '#111111',
      textAlign: 'left',
      fontSize: '1.1rem',
    },
    h4: {
      color: '#476282',
      textAlign: 'left',
      marginBottom: 8,
      fontSize: '0.9rem',
    },
  },
  palette: {
    mode: 'light',
    black: {
      main: '#000000',
      light: '#000000',
    },
    white: {
      main: '#ffffff',
      contrastText: '#000000',
    },
    primary: {
      main: '#157EE5',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#1F0322',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#B71C1C',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#111111',
    },
    background: {
      default: '#f6f6f6',
      paper: '#fafafa',
    },
  },
});

const pickerTheme = createTheme({
  palette: {
    black: {
      main: '#000000',
      light: '#ffffff',
    },
    primary: {
      main: '#F76C6C',
      contrastText: '#FFFFFF',
    },
  },
});

export { pickerTheme };
